export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    if(window.location.hostname === "localhost"){
        window.location.href = "http://localhost:3000/login";
    }else{
        window.location.href = "https://lucrotech.appandwebstudio.com.br/login";
    }
}